import React, { useState, useContext } from 'react';
import Header from '../Comman/Header';
import { LuArrowLeft, LuSend, LuCircleX, LuType, LuFileText, LuUpload, LuX } from 'react-icons/lu';
import { Link, useNavigate } from 'react-router-dom';
import { MdCategory } from 'react-icons/md';
import axios from 'axios';
import { OnmaxContext } from '../../OnmaxContext';

function CreateTicket() {
    const { account, toastSuccess, toastError } = useContext(OnmaxContext);
    const [subject, setSubject] = useState("");
    const [category, setCategory] = useState("general");
    const [priority, setPriority] = useState("medium");
    const [message, setMessage] = useState("");
    const [image, setImage] = useState(null);
    const [imageBase64, setImageBase64] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (file) {
            if (file.size > 5 * 1024 * 1024) {
                toastError("Image size must be less than 5MB");
                return;
            }
            if (!file.type.startsWith("image/")) {
                toastError("Only image files are allowed");
                return;
            }
            setImage(file);
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setImageBase64(reader.result);
            };
        }
    };

    const removeImage = () => {
        setImage(null);
        setImageBase64("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!subject || !category || !message) {
            toastError("Missing required fields");
            return;
        }
        setLoading(true);
        try {
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "support",
                submethod: "createtickt",
                key: process.env.REACT_APP_KEY,
                userAddress: account || localStorage.getItem("username") || "",
                subject,
                category,
                priority,
                message,
                image: imageBase64
            });
            if (res.data?.resCode === 200 || res.data?.message === "Ticket created successfully") {
                toastSuccess("Ticket created successfully");
                navigate("/support/my-tickets");
            } else {
                toastError(res.data?.message || "Failed to create ticket");
            }
        } catch (error) {
            toastError("Error creating ticket");
        } finally {
            setLoading(false);
        }
    };
    const CSS = `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

        .db-scene {
            background: #e8ecf1;
            min-height: 100vh;
            font-family: 'Inter', -apple-system, sans-serif;
            padding: 28px 20px;
            color: #1e293b;
            position: relative;
            overflow-x: hidden;
            perspective: 1600px;
        }

        .db-profile-card {
            position: relative;
            background: rgba(255, 255, 255, 0.7);
            backdrop-filter: blur(25px);
            border: 1px solid rgba(255, 255, 255, 0.4);
            border-radius: 44px;
            padding: 40px;
            transform-style: preserve-3d;
            transition: all 0.7s cubic-bezier(0.23, 1, 0.32, 1);
            box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
            overflow: hidden;
            margin-bottom: 40px;
        }

        .db-card-border-anim {
            position: absolute;
            bottom: 0; left: 0; right: 0; height: 4px;
            background: linear-gradient(90deg, #006fe3, #8b5cf6, #f59e0b, #006fe3);
            background-size: 300% 100%;
            animation: dbBorderRun 4s linear infinite;
            z-index: 10;
        }
        @keyframes dbBorderRun { 0%{background-position:0% 50%} 100%{background-position:100% 50%} }

        .db-input-group {
            margin-bottom: 24px;
            width: 100%;
        }

        .db-label {
            font-size: 12px;
            font-weight: 800;
            color: #1a2234;
            text-transform: uppercase;
            letter-spacing: 1.2px;
            margin-left: 20px;
            margin-bottom: 10px;
            display: block;
            text-align: left;
        }

        /* --- AFFILIATE THEME INPUTS --- */
        .db-input-wrapper {
            background: rgba(238, 242, 246, 0.5); 
            border-radius: 16px; 
            padding: 12px 20px; 
            border: 1px solid rgba(255, 255, 255, 0.8);
            box-shadow: 1px 20px 20px 0px #bfc9d8, 0 10px 20px rgba(0, 0, 0, 0.05), inset 0 1px 0 #ffffff;
            display: flex; 
            align-items: center; 
            gap: 12px;
            position: relative;
            transition: all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
        }
        
        .db-input-wrapper:focus-within {
            background: #ffffff;
            border-color: #006fe3;
            transform: translateY(-2px);
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08), 1px 20px 20px 0px #bfc9d8, inset 0 1px 0 #ffffff;
        }

        .db-input-icon-box {
            width: 42px;
            height: 42px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 12px;
            font-size: 18px;
            background: #fff;
            box-shadow: 2px 5px 10px rgba(0,0,0,0.05);
            flex-shrink: 0;
        }
        .icon-blue { color: #006fe3; }
        .icon-cyan { color: #0ea5e9; }
        .icon-yellow { color: #f59e0b; }
        .icon-purple { color: #8b5cf6; }

        .db-input {
            background: transparent !important; 
            border: none !important; 
            outline: none !important; 
            width: 100%; 
            font-weight: 700; 
            color: #1e293b !important; 
            font-size: 15px;
            padding: 5px 0;
        }
        .db-input::placeholder { color: #94a3b8; font-weight: 600; }

        .db-select {
            appearance: none;
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2394a3b8' %3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
            background-repeat: no-repeat;
            background-position: right 0 center;
            background-size: 18px;
            padding-right: 30px;
        }

        .db-textarea {
            resize: none;
            min-height: 120px;
            align-items: flex-start !important;
            padding-top: 15px !important;
        }

        .effective-btn-gold {
            background: linear-gradient(135deg, #f59e0b, #d97706) !important;
            box-shadow: 1px 15px 25px rgba(245, 158, 11, 0.3) !important;
            border: none !important;
            color: white !important;
            height: 60px !important;
            border-radius: 20px !important;
            font-weight: 800 !important;
            font-size: 16px !important;
            letter-spacing: 1px !important;
            text-transform: uppercase !important;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            transition: all 0.3s !important;
            width: 100%;
            text-decoration: none;
        }

        .effective-btn-gold:hover {
            transform: translateY(-3px) scale(1.02);
            filter: brightness(1.1);
            box-shadow: 1px 20px 35px rgba(245, 158, 11, 0.4) !important;
            color: white !important;
        }

        .db-btn-white {
            background: #ffffff !important;
            box-shadow: 1px 10px 20px rgba(0,0,0,0.05), 0 5px 10px rgba(191,201,216,0.3) !important;
            border: 1px solid rgba(255,255,255,0.8) !important;
            color: #64748b !important;
            height: 60px !important;
            border-radius: 20px !important;
            font-weight: 800 !important;
            text-transform: uppercase !important;
            transition: all 0.3s !important;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            text-decoration: none;
        }

        .db-btn-white:hover {
            background: #f8fafc !important;
            color: #1e293b !important;
            transform: translateY(-2px);
        }

        .back-btn {
            width: 44px;
            height: 44px;
            border-radius: 12px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #64748b;
            transition: all 0.3s;
            text-decoration: none;
            box-shadow: 1px 5px 15px rgba(0,0,0,0.05);
        }
        .back-btn:hover { background: #006fe3; color: white; transform: translateX(-3px); }

        /* --- UPLOAD AREA --- */
        .db-upload-area {
            border: 2px dashed rgba(255, 255, 255, 0.8);
            background: rgba(238, 242, 246, 0.3);
            border-radius: 20px;
            padding: 30px 20px;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .db-upload-area:hover {
            background: rgba(255, 255, 255, 0.9);
            border-color: #006fe3;
        }
        .db-upload-icon {
            font-size: 28px;
            color: #64748b;
            margin-bottom: 10px;
            transition: color 0.3s;
        }
        .db-upload-area:hover .db-upload-icon {
            color: #006fe3;
        }
        .db-upload-text {
            font-size: 13px;
            font-weight: 800;
            color: #1e293b;
            text-transform: uppercase;
            letter-spacing: 1px;
        }
        .db-upload-subtext {
            font-size: 11px;
            font-weight: 600;
            color: #94a3b8;
            margin-top: 5px;
        }
        
        .db-file-card {
            background: rgba(255, 255, 255, 0.9);
            border: 1px solid rgba(0, 111, 227, 0.2);
            border-radius: 16px;
            padding: 15px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0 10px 20px rgba(0,0,0,0.03);
        }
        .db-file-info {
            display: flex;
            align-items: center;
            gap: 15px;
        }
        .db-file-icon-box {
            width: 40px;
            height: 40px;
            background: rgba(0, 111, 227, 0.1);
            color: #006fe3;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
        }
        .db-file-name {
            font-size: 13px;
            font-weight: 800;
            color: #1e293b;
            margin: 0;
            line-height: 1.2;
            max-width: 200px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .db-file-size {
            font-size: 10px;
            font-weight: 700;
            color: #94a3b8;
            margin: 0;
            text-transform: uppercase;
        }
        .db-file-remove {
            background: rgba(239, 68, 68, 0.1);
            color: #ef4444;
            border: none;
            width: 32px;
            height: 32px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s;
        }
        .db-file-remove:hover {
            background: #ef4444;
            color: white;
        }

        /* RESPONSIVE */
        @media (max-width: 991px) {
            .db-profile-card { padding: 30px; border-radius: 35px; }
            .db-scene { padding: 15px 10px; }
            .h1 { font-size: 22px !important; }
        }

        @media (max-width: 576px) {
            .db-input-group { margin-bottom: 20px; }
            .db-btn-send { width: 100%; border-radius: 15px; }
            .h1 { font-size: 18px !important; }
            .back-btn { padding: 8px 12px; font-size: 9px; }
        }
        .header-icon-box {
            width: 48px;
            height: 48px;
            background: #fff;
            border-radius: 14px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 4px 10px 20px rgba(0,0,0,0.05);
            color: #f59e0b;
            font-size: 20px;
        }
    `;

    return (
        <div className="body-bg">
            <style>{CSS}</style>
            <Header />
            <section className="nftmax-adashboard nftmax-show">
                <div className="db-scene" style={{ borderRadius: '29px' }}>
                    <div className="container">

                        {/* Perfect Header Area */}
                        <div className="d-flex align-items-center justify-content-between mb-2 px-3">
                            <div className="d-flex align-items-center gap-3">
                                {/* <div className="header-icon-box">
                                    <LuPlus />
                                </div> */}
                                <div className="text-start">
                                    <h1 className="mb-0 fw-black" style={{ fontWeight: 900, color: '#1e293b', fontSize: '26px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Initialize Ticket</h1>
                                    {/* <p className="mb-0 text-uppercase fw-bold opacity-50" style={{ fontSize: '11px', letterSpacing: '1.5px', color: '#64748b' }}>Formalize an inquiry within the protocol registry</p> */}
                                </div>
                            </div>
                            <Link to="/support" className="back-btn">
                                <LuArrowLeft size={24} />
                            </Link>
                        </div>

                        {/* Form Card */}
                        <div className="db-profile-card">
                            {/* <div className="db-card-border-anim" /> */}

                            <form className="text-start" onSubmit={handleSubmit}>
                                <div className="db-input-group">
                                    <label className="db-label">Subject Line</label>
                                    <div className="db-input-wrapper">
                                        <div className="db-input-icon-box icon-blue">
                                            <LuType />
                                        </div>
                                        <input type="text" className="db-input" placeholder="Brief summary of technical anomaly" value={subject} onChange={(e) => setSubject(e.target.value)} required />
                                    </div>
                                </div>

                                <div className="row g-4 mb-2">
                                    <div className="col-md-6">
                                        <div className="db-input-group">
                                            <label className="db-label">Category</label>
                                            <div className="db-input-wrapper">
                                                <div className="db-input-icon-box icon-cyan">
                                                    <MdCategory />
                                                </div>
                                                <select className="db-input db-select" value={category} onChange={(e) => setCategory(e.target.value)}>
                                                    <option value="general">General Inquiry</option>
                                                    <option value="technical">Technical Support</option>
                                                    <option value="payment">Payment Issue</option>
                                                    <option value="account">Account Access</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="db-input-group">
                                            <label className="db-label">Priority Level</label>
                                            <div className="db-input-wrapper">
                                                <div className="db-input-icon-box icon-yellow">
                                                    {/* <LuAlertTriangle /> */}
                                                    <MdCategory />

                                                </div>
                                                <select className="db-input db-select" value={priority} onChange={(e) => setPriority(e.target.value)}>
                                                    <option value="low">Low Impact</option>
                                                    <option value="medium">Medium Impact</option>
                                                    <option value="high">Critical Impact</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="db-input-group mt-2">
                                    <label className="db-label">Detailed Chronicle</label>
                                    <div className="db-input-wrapper db-textarea">
                                        <div className="db-input-icon-box icon-purple">
                                            <LuFileText />
                                        </div>
                                        <textarea className="db-input" rows="6" placeholder="Provide a detailed chronicle of the anomaly encountered..." style={{ height: '140px' }} value={message} onChange={(e) => setMessage(e.target.value)} required></textarea>
                                    </div>
                                </div>

                                {/* Attachment Upload */}
                                <div className="db-input-group mt-3">
                                    <label className="db-label">Supporting Evidence (Optional)</label>
                                    {!image ? (
                                        <label className="db-upload-area">
                                            <LuUpload className="db-upload-icon" />
                                            <div className="db-upload-text">Append Image Document</div>
                                            <div className="db-upload-subtext">MAX 5MB • JPG, PNG, GIF</div>
                                            <input type="file" className="d-none" accept="image/*" onChange={handleFileChange} />
                                        </label>
                                    ) : (
                                        <div className="db-file-card">
                                            <div className="db-file-info">
                                                <div className="db-file-icon-box">
                                                    <img src={imageBase64} alt="preview" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }} />
                                                </div>
                                                <div>
                                                    <p className="db-file-name">{image.name}</p>
                                                    <p className="db-file-size">{(image.size / 1024).toFixed(0)} KB SIZE</p>
                                                </div>
                                            </div>
                                            <button type="button" className="db-file-remove" onClick={removeImage}>
                                                <LuX size={18} />
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="row g-3 mt-4">
                                    <div className="col-md-8">
                                        <button type="submit" className="effective-btn-gold" disabled={loading}>
                                            <LuSend className="me-2" /> {loading ? "Launching..." : "Launch Inquiry"}
                                        </button>
                                    </div>
                                    <div className="col-md-4">
                                        <Link to="/support" className="db-btn-white">
                                            <LuCircleX className="me-2" size={18} /> Abort
                                        </Link>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default CreateTicket;